import select2 from "select2";

export default () => {
  const params = {
    selectItem: $(".contact-form__employees"),
    textAreaLink: $(".js-textarea-link"),
    textareaItem: $(".js-textarea"),
    apiCheckboxes: $(".form__item--api"),
    checkboxAccept: $(".js-checkbox-api-yes"),
    checkboxDiscard: $(".js-checkbox-api-no")
  };

  const customSelect = () => {
    params.selectItem.select2({
      selectOnClose: false,
      minimumResultsForSearch: Infinity
    });

    $(".select2").after($("select.contact-form__employees"));

    const hideCustomSelectError = event => {
      const parsley = $(event.target).next(".parsley-errors-list");
      if (parsley.length) parsley.remove();
    };

    params.selectItem.on("select2:open", function(event) {
      hideCustomSelectError(event);
    });
    params.selectItem.on("select2:close", function(event) {
      hideCustomSelectError(event);
    });
  };

  const textAreaHandler = () => {
    params.textAreaLink.on("click", function(e) {
      e.preventDefault();
      params.textareaItem.slideToggle();
      $(this).toggleClass("is-active");
      $(this).text(function(i, text) {
        return text === "Describe your use-case (optional)"
          ? "Hide window"
          : "Describe your use-case (optional)";
      });
    });
  };

  const checkboxAccessibility = () => {
    params.checkboxAccept.on("keydown", function(event) {
      const keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode === 13) {
        event.preventDefault();
        $("#checkbox-api-yes").trigger("click");
      }
    });

    params.checkboxDiscard.on("keydown", function(event) {
      const keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode === 13) {
        event.preventDefault();
        $("#checkbox-api-no").trigger("click");
      }
    });
  };

  const modalSelectInit = () => {
    const selectFieldModal = $(".modal-employees");
    const selectFieldParent = $(".modal-employees").parent();
    const selectWrapper = $(".modal .form__item--employees");
    const customSelectField = $(".modal .select2");
    const windowWidth = $(window).width();

    if (windowWidth < 746 && selectFieldModal.length < 2) {
      selectFieldModal.select2({
        selectOnClose: false,
        minimumResultsForSearch: Infinity,
        dropdownParent: selectFieldParent
      });

      selectFieldModal.on('select2:open', function (e) {
        const evt = "scroll.select2";
        $(e.target).parents().off(evt);
        $(window).off(evt);
      });
    } else {
      selectFieldModal.select2({
        selectOnClose: false,
        minimumResultsForSearch: Infinity
      });
    }

    if (selectFieldModal.length >= 1) {
      selectWrapper.addClass("multiple");
    } else {
      customSelectField.after($("select.modal-employees"));
    }

    const hideCustomSelectError = event => {
      const parsley = $(event.target).next(".parsley-errors-list");
      if (parsley.length) parsley.remove();
    };

    selectFieldModal.on("select2:open", function(event) {
      hideCustomSelectError(event);
    });
    selectFieldModal.on("select2:close", function(event) {
      hideCustomSelectError(event);
    });
  };

  customSelect();

  if ($(".modal-employees").length > 0) {
    modalSelectInit();
  }

  if (params.textareaItem.length) {
    textAreaHandler();
  }

  if (params.apiCheckboxes.length) {
    checkboxAccessibility();
  }

  const resetForm = () => {
    const formWrapper = $("#form-user-data");
    formWrapper.trigger("reset");
  };

  const handleInputType = () => {
    const trigger = $(".js-show-pass");

    if (trigger.length) {
      trigger.on("click", function() {
        $(this)
          .parents(".form__item")
          .find(".form-control-pass")
          .attr("type", (index, attr) =>
            attr === "password" ? "text" : "password"
          );
      });
    }
  };

  handleInputType();

  resetForm();
};
